import { EventLogEntry } from '@jetfabric/schemas/lib/protocol-sdk-api-v2/events';
import { OPERATORS } from '@jetfabric/schemas/lib/protocol-sdk-api-v2/query/condition';
import { V2Query } from '@jetfabric/schemas/lib/protocol-sdk-api-v2/query/queries';
import {
  EVERY,
  ExecutionEnvironment,
  TraceEventType,
  TraceMessage,
  TraceMessageBody,
  TraceMessageType,
  TraceOptions,
  TraceQueryContext,
  TraceState,
} from '@jetfabric/schemas/lib/protocol-sdk-api-v2/query/trace';

export const getTraceTimestamp = (traceState: TraceState) =>
  traceState?.getTraceTimestamp?.() || {};

// This is not necessarily the best package for this code, but it's available to both SDK and API
export const createTraceQueryContext = (
  traceState: TraceState,
  query: V2Query,
  executionEnvironment?: ExecutionEnvironment
): TraceQueryContext => {
  const newContext: TraceQueryContext = {
    type: TraceEventType.QueryContext,
    query: query,
    timestamp: getTraceTimestamp(traceState),
    children: [],
    executionEnvironment,
  };
  traceState.context.children.push(newContext);
  return newContext;
};

export const createTraceMessageEntry = (
  traceState: TraceState | undefined,
  message: TraceMessageBody | (() => TraceMessageBody)
) => {
  if (traceState) {
    traceState.context.children.push({
      type: TraceEventType.TraceMessage,
      timestamp: getTraceTimestamp(traceState),
      message: typeof message === 'function' ? message() : message,
    });
  }
};

export const tracingEnabled = (
  traceState: TraceState,
  checkType: keyof TraceOptions,
  value: string
) => {
  if (traceState.options[checkType] === EVERY || traceState.options[checkType] === value) {
    return true;
  }
  if (
    Array.isArray(traceState.options[checkType]) &&
    (traceState.options[checkType].includes(EVERY) ||
      traceState.options[checkType].includes(value as any))
  ) {
    return true;
  }
  return false;
};

export function isTraceQueryContext(traceEvent: any): traceEvent is TraceQueryContext {
  return typeof traceEvent === 'object' && traceEvent.type === TraceEventType.QueryContext;
}
